import { render, staticRenderFns } from "./BulkReset.vue?vue&type=template&id=f77b36a0&scoped=true&"
import script from "./BulkReset.vue?vue&type=script&lang=js&"
export * from "./BulkReset.vue?vue&type=script&lang=js&"
import style0 from "./BulkReset.vue?vue&type=style&index=0&id=f77b36a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77b36a0",
  null
  
)

export default component.exports